import { render, staticRenderFns } from "./fotosEssenciais.vue?vue&type=template&id=17765667&"
import script from "./fotosEssenciais.vue?vue&type=script&lang=js&"
export * from "./fotosEssenciais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports